import { render, staticRenderFns } from "./ValidatableDeliveryBasises.vue?vue&type=template&id=9338d2fe&"
import script from "./ValidatableDeliveryBasises.vue?vue&type=script&lang=js&"
export * from "./ValidatableDeliveryBasises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports